import React, { useEffect, useState } from "react";
import ScrollToTop from "../Theme2DashboardTabs/ScrollToTop";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { SendPostRequest } from "../../http";
import { formatDate, limitParagraphByCharLimit } from "../../Helper/Helper";
import { Modal, Box, Typography, Button } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";

function FirstDarkFooter() {
  const [newsData, setNewsData] = useState([]);
  const [contactData, setContactData] = useState([]);
  const sitedata = useSelector((store) => store.global.loginData);
  const [shuffledNews, setShuffledNews] = useState([]);

  useEffect(() => {
    getContactData();
  }, []);

  const getContactData = async () => {
    const response = await SendPostRequest("content/contactus");
    setContactData(response?.data);
  };
  // Function to extract src from iframe HTML
  const extractMapSrc = (iframeHtml) => {
    if (!iframeHtml) return null;
    const srcMatch = iframeHtml.match(/src="([^"]*)"/);
    return srcMatch ? srcMatch[1] : null;
  };
  const openGoogleMap = () => {
    if (contactData && contactData.length > 0 && contactData[0].google_map) {
      const mapSrc = extractMapSrc(contactData[0].google_map);
      if (mapSrc) {
        window.open(mapSrc, "_blank");
      } else if (sitedata?.site_address) {
        const encodedAddress = encodeURIComponent(sitedata.site_address);
        window.open(`https://www.google.com/maps/search/?api=1&query=${encodedAddress}`, "_blank");
      }
    }
  };

  const [open, setOpen] = useState(false);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const charLimit = 198;
  const fullText = sitedata?.short_description || "";
  const isLong = fullText.length > charLimit;
  const shortText = isLong ? fullText.substring(0, charLimit) : fullText;

  useEffect(() => {
    getNewsData();
  }, []);
  const getNewsData = async () => {
    const response = await SendPostRequest("news/list");

    const shuffled = [...(response?.data || [])]
      .sort(() => Math.random() - 0.5)
      .slice(0, 2);

    setNewsData(response?.data);
    setShuffledNews(shuffled);
  };

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const hasCallUsContent =
    sitedata?.advertisement?.callus_heading ||
    sitedata?.advertisement?.callus_detail;
  return (
    <div>
      {hasCallUsContent && (
        sitedata?.theme_contact_us_bar === "split-form" ? (
          <section
            id="section-contact"
            className="contact-form-section section-bg-img o-visible py-5"
            style={{ backgroundImage: 'url("/assets/images/mist/contact-us-bar-split-form.webp")' }}
          >
            <div className="shape-bottom" data-negative="false">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 1000 100"
                preserveAspectRatio="none"
              >
                <path
                  className="shape-fill"
                  opacity="0.33"
                  d="M473,67.3c-203.9,88.3-263.1-34-320.3,0C66,119.1,0,59.7,0,59.7V0h1000v59.7
                          c0,0-62.1,26.1-94.9,29.3c-32.8,3.3-62.8-12.3-75.8-22.1C806,49.6,745.3,8.7,694.9,4.7S492.4,59,473,67.3z"
                ></path>
                <path
                  className="shape-fill"
                  opacity="0.66"
                  d="M734,67.3c-45.5,0-77.2-23.2-129.1-39.1c-28.6-8.7-150.3-10.1-254,39.1
                          s-91.7-34.4-149.2,0C115.7,118.3,0,39.8,0,39.8V0h1000v36.5c0,0-28.2-18.5-92.1-18.5C810.2,18.1,775.7,67.3,734,67.3z"
                ></path>
                <path
                  className="shape-fill"
                  d="M766.1,28.9c-200-57.5-266,65.5-395.1,19.5C242,1.8,242,5.4,184.8,20.6
                          C128,35.8,132.3,44.9,89.9,52.5C28.6,63.7,0,0,0,0h1000c0,0-9.9,40.9-83.6,48.1S829.6,47,766.1,28.9z"
                ></path>
              </svg>
            </div>
            <div className="container">
              <div className="row">
                <div className="col-xl-4 pe-xl-4 pb-5 pb-xl-0">
                  <div className="flip-box broken-top-115 verticalMove">
                    <div className="flip-box-inner imghvr-flip-3d-horz">
                      <div className="flip-box-front">
                        <div className="flip-box-icon margin-bottom-40">
                          <span className="text-center flip-icon-middle ti-headphone-alt text-white"></span>
                        </div>
                        <h3 className="flip-box-title margin-bottom-30 text-white">
                          Reach Us
                        </h3>
                        <div className="flip-content text-white">
                          <p style={{ cursor: "pointer" }} onClick={openGoogleMap}>
                            {sitedata?.site_address ||
                              "--"}
                          </p>
                          <p className="text-white">
                            <a
                              className="text-white"
                              href={`tel:${sitedata?.advertisement?.callus_number ||
                                "--"
                                }`}
                            >
                              {sitedata?.advertisement?.callus_number ||
                                "--"}
                            </a>
                          </p>
                          <p className="text-white">
                            <a
                              className="text-white"
                              href={`mailto:${sitedata?.business_email || sitedata?.site_email || "#"
                                }`}
                            >
                              {sitedata?.business_email || sitedata?.site_email || "--"}
                            </a>
                          </p>
                        </div>
                      </div>
                      <div className="flip-box-back">
                        <h3 className="flip-box-title">Reach Us</h3>
                        <div className="flip-content">
                          <p style={{ cursor: "pointer" }} onClick={openGoogleMap}>
                            {sitedata?.site_address ||
                              "--"}
                          </p>
                          <p>
                            <a
                              href={`tel:${sitedata?.advertisement?.callus_number ||
                                "#"
                                }`}
                            >
                              {sitedata?.advertisement?.callus_number ||
                                "--"}
                            </a>
                          </p>
                          <p>
                            <a
                              href={`mailto:${sitedata?.business_email || sitedata?.site_email || "zegenchurch@mail.com"
                                }`}
                            >
                              {sitedata?.business_email || sitedata?.site_email || "--"}
                            </a>
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-xl-8 ps-xl-4">
                  <div className="section-title-wrapper">
                    <div className="title-wrap mb-0">
                      <div className="section-title">
                        <h3 className="section-title typo-white text-uppercase">
                          {/* Contact Us For Appointment */}
                          {sitedata?.advertisement?.callus_heading || null}
                        </h3>
                        <span className="section-border-bottom"></span>
                      </div>
                      <div className="pad-top-15">
                        <h5 className="margin-bottom-10 typo-white">
                          {/* We are proud to serve you 24/7. Just Call Us when you
                              need. */}
                          {sitedata?.advertisement?.callus_detail || null}
                        </h5>
                      </div>
                    </div>

                    {/* <div className="button-section margin-top-25 d-flex gap-3 flex-wrap">
                          {sitedata?.permissions?.appointment === "show" && (
                            <Link
                              target="_blank"
                              to={"/appointment"}
                              className="btn btn-default"
                            >
                              Book Appointment
                            </Link>
                          )}
                        </div> */}
                    <div className="button-section margin-top-25 d-flex gap-3 flex-wrap">
                      {sitedata?.permissions?.appointment === "show" &&
                        sitedata?.advertisement?.callus_button && (
                          <a
                            href={sitedata?.advertisement?.callus_button_url || "#"}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="btn btn-default"
                          >
                            {sitedata?.advertisement?.callus_button}
                          </a>
                        )}
                    </div>

                  </div>
                </div>
              </div>
            </div>
          </section>
        ) : (
          <section
            id="get-quote-section"
            className="get-quote-section bg-theme pad-none pad-top-md-none pad-bottom-md-none relative o-visible index-1"
          >
            <div className="container">
              <div className="b-radius-8 pad-top-50 pad-bottom-45 pe-5 pe-lg-0 ps-lg-0 ps-5">
                <div className="row get-quote-1 d-flex align-items-center">
                  <div className="col-lg-2 align-self-center">
                    <div className="quote-icon">
                      <img
                        src="/assets/images/icons/phone-call.png"
                        className="img-fluid thumb ms-0 ms-lg-auto"
                        width="100"
                        height="100"
                        alt="events-img"
                      />
                    </div>
                  </div>
                  <div className="col-lg-5  br-right">
                    <div className="title-wrap mb-0">
                      <div className="section-title mb-0">
                        {!isMobile ? (<h3 className="title mb-3 mb-lg-1 acheivement-bottom-text" style={{ fontSize: "32px" }}>
                          {sitedata?.advertisement?.callus_detail ||
                            ""}
                        </h3>) : null}
                        {isMobile ? (<h3 className="acheivement-bottom-text mb-0 w-100">
                          {/* Call Us Anytime */}
                          {sitedata?.advertisement?.callus_heading}

                        </h3>) : null}

                      </div>
                    </div>
                  </div>
                  <div className="col-lg-5" >
                    <div className="contact-info pl-lg-5 pl-sm-0">
                      {!isMobile ? (<h3 className="acheivement-bottom-text mb-0 w-100">
                        {/* Call Us Anytime */}
                        {sitedata?.advertisement?.callus_heading}

                      </h3>) : null}
                      {isMobile ? (<h5 className="acheivement-bottom-text-color mb-0 mb-lg-1 " style={{ fontSize: "22px", color: "#FFF" }}>
                        {sitedata?.advertisement?.callus_detail ||
                          ""}
                      </h5>) : null}

                      <h5 className="acheivement-bottom-text-color" style={{ fontSize: isMobile ? "22px" : "26px", color: "white" }}>
                        {sitedata?.advertisement?.callus_number ? (
                          <a
                            href={`https://wa.me/${sitedata?.advertisement?.callus_number}`}
                          >
                            {sitedata?.advertisement?.callus_number}
                          </a>
                        ) : (
                          null
                        )}</h5>
                      {sitedata?.permissions?.appointment === "show" &&
                        sitedata?.advertisement?.callus_button && (
                          <div className="get-quote-3  button">
                            <Link
                              className="btn btn-border"
                              target="_blank"
                              href={sitedata?.advertisement?.callus_button_url || "#"}
                            >
                              {sitedata?.advertisement?.callus_button || "--"}
                            </Link>
                          </div>
                        )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        )
      )}




      <footer id="footer" className="footer bg-grey2 footer-1">
        <div className="footer-widgets">
          <div className="footer-middle-wrap bg-dark text-white">
            <div className="container">
              <div className="row">
                <div className="col-lg-3 widget text-widget">
                  <div className="widget-title">
                    {sitedata?.site_type === "hospitals" ? (
                      <h3 className="title text-uppercase">About Us</h3>
                    ) : (
                      <h3 className="title text-uppercase">About Me</h3>
                    )}
                  </div>
                  <div className="widget-text margin-bottom-15">
                    <p
                      className="text-white"
                      dangerouslySetInnerHTML={{
                        __html: isLong
                          ? shortText + "... <button style='color:white; background:none; border:none; cursor:pointer; font-weight:bold;'>Read More</button>"
                          : shortText,
                      }}
                      onClick={(e) => {
                        if (e.target.tagName === "BUTTON") {
                          handleOpen();
                        }
                      }}
                    />
                    <div className="get-quote-3 button text-white">
                      {sitedata?.site_type === "hospitals" ? (
                        <Link
                          className="btn btn-border"
                          target="_blank"
                          to={"/doctors"}
                        >
                          Find Doctors
                        </Link>
                      ) : (
                        <Link
                          className="btn btn-border"
                          target="_blank"
                          to={"/about"}
                        >
                          Doctor's Bio
                        </Link>
                      )}
                    </div>
                  </div>
                </div>
                <div className="col-lg-3 widget text-widget">
                  <div className="widget-title">
                    <h3 className="title text-uppercase">Links</h3>
                  </div>
                  {/* <div className="menu-quick-links footer-links text-white">
                    <ul className="menu dark-footer-menu-item">
                      <li className="menu-item ">
                        <Link to={"/"}>Home</Link>
                      </li>
                      <li className="menu-item">
                        <Link to={"/about"}>About</Link>
                      </li>
                      {sitedata?.site_type === "hospitals" && (
                        <li className="menu-item">
                          <Link to={"/doctors"}>Doctors</Link>
                        </li>
                      )}
                      <li className="menu-item">
                        <Link to={"/gallery"}>Gallery</Link>
                      </li>
                      {sitedata?.site_type === "hospitals" && (
                        <li className="menu-item">
                          <Link to={"/specialities"}>Specialties</Link>
                        </li>
                      )}
                      <li className="menu-item">
                        <Link to={"/blogs"}>Blogs</Link>
                      </li>
                    </ul>
                  </div> */}
                  <div className="menu-quick-links footer-links">
                    <ul className="row menu dark-footer-menu-item" style={{ paddingLeft: "15px", paddingRight: "15px" }}>
                      <li className="col-lg-6 col-md-6 col-6 menu-item">
                        <Link to={"/"}>Home</Link>
                      </li>
                      <li className="col-lg-6 col-md-6 col-6 menu-item">
                        <Link to={"/about"}>About</Link>
                      </li>
                      {sitedata?.site_type === "hospitals" && (
                        <li className="col-lg-6 col-md-6 col-6 menu-item">
                          <Link to="/doctors">Doctors</Link>
                        </li>
                      )}
                      <li className="col-lg-6 col-md-6 col-6 menu-item">
                        <Link to={"/gallery"}>Gallery</Link>
                      </li>
                      {sitedata?.site_type === "hospitals" && (
                        <li className="col-lg-6 col-md-6 col-6 menu-item">
                          <Link to={"/specialities"}>Specialties</Link>
                        </li>
                      )}
                      <li className="col-lg-6 col-md-6 col-6 menu-item">
                        <Link to={"/blogs"}>Blogs</Link>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="col-lg-3 widget recent-posts">
                  <div className="widget-title">
                    <h3 className="title text-uppercase">Latest News</h3>
                  </div>
                  <nav>
                    <ul className="footer-list-posts">
                      {shuffledNews.map((item, index) => (
                        <li key={index}>
                          <div className="side-image">
                            <Link to={`/news/detail/${item?.slug}`}>
                              <img
                                style={{ height: "80px", maxWidth: "90px" }}
                                src={item?.image}
                                className="img-responsive wp-post-image m-0"
                                alt="Blog"
                              />
                            </Link>
                          </div>

                          <div className="side-item-text pl-3">
                            <Link
                              to={`/news/detail/${item?.slug}`}
                             >{item?.title}</Link>
                            <span className="post-date d-block">
                              {formatDate(item?.date)}
                            </span>
                          </div>
                        </li>
                      ))
                      }
                    </ul>
                  </nav>
                </div>

                <div className="col-lg-3 widget text-widget">
                  <div className="widget-title">
                    <h3 className="title text-uppercase">Contact Details</h3>
                  </div>
                  <nav>
                    <ul className="contact-info">
                      <li>
                        <i
                          aria-hidden="true"
                          className="ti-headphone theme-color"
                        ></i>
                        <span>
                          <a
                            href={`tel:${sitedata?.site_contact}`}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            {sitedata?.site_contact}
                          </a>
                        </span>
                      </li>
                      <li>
                        <i
                          aria-hidden="true"
                          className="ti-email theme-color"
                        ></i>
                        <span>
                          {" "}
                          <a href={`mailto:${sitedata?.business_email || sitedata?.site_email}`}>
                            {sitedata?.business_email || sitedata?.site_email}
                          </a>
                        </span>
                      </li>

                      <li>
                        <i
                          aria-hidden="true"
                          className="ti-location-pin theme-color"
                        ></i>{" "}
                        <span>
                          {" "}
                          <a style={{ cursor: "pointer" }} onClick={openGoogleMap}>
                            {sitedata?.site_address || "No address provided."}
                          </a>
                        </span>
                      </li>
                    </ul>
                  </nav>

                  <div className="social-icons mb-3">
                    {sitedata?.site_extra?.facebook_link && (
                      <a
                        href={sitedata?.site_extra?.facebook_link}
                        className="social-fb"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <span className="ti-facebook"></span>
                      </a>
                    )}
                    {sitedata?.site_extra?.twitter_link && (
                      <a
                        href={sitedata?.site_extra?.twitter_link}
                        className="social-twitter"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <span className="fab fa-x-twitter"></span>
                      </a>
                    )}
                    {sitedata?.site_extra?.instagram_link && (
                      <a
                        href={sitedata?.site_extra?.instagram_link}
                        className="social-instagram"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <span className="ti-instagram"></span>
                      </a>
                    )}
                    {sitedata?.site_extra?.linkedin_link && (
                      <a
                        href={sitedata?.site_extra?.linkedin_link}
                        className="social-instagram"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <span className="ti-linkedin"></span>
                      </a>
                    )}
                    {sitedata?.site_extra?.tiktok_link && (
                      <a
                        href={sitedata?.site_extra?.tiktok_link}
                        className="social-tiktok"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <span className="fab fa-tiktok"></span>
                      </a>
                    )}
                    {sitedata?.site_extra?.youtube_link && (
                      <a
                        href={sitedata?.site_extra?.youtube_link}
                        className="social-tiktok"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <span className="fab fa-youtube"></span>
                      </a>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="footer-copyright bg-grey">
          <div className="footer-bottom-wrap bg-dark text-white pad-tb-20">
            <div className="container">
              <div className="row">
                <div className="col-md-12 copyright-section">
                  <ul className="footer-bottom-items pull-left">
                    <li className="nav-item">
                      <div className="nav-item-inner copyright">
                        Copyrights © {new Date()?.getFullYear()}{" "}
                        <a target="_blank" href="https://clinta.biz/">
                          ClinTa
                        </a>
                        . Powered by
                        <a
                          href="https://dright.net/"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {" "}
                          D-Right Technologies
                        </a>
                      </div>
                    </li>
                  </ul>
                  <ScrollToTop />
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>

      <Modal open={open} onClose={handleClose}>
        <Box
          sx={{
            position: "absolute",
            top: isMobile ? "50%" : "40%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: isMobile ? 360 : 500,
            bgcolor: "background.paper",
            borderRadius: 2,
            boxShadow: 24,
            p: 2,
          }}
        >
          {/* <Typography variant="h6" mb={2}>
                        Full Description
                      </Typography> */}
          <Box textAlign="right" mt={2} mb={4}>
            <IconButton
              onClick={handleClose}
              className="newslatterpopup-close-btn"
              sx={{
                position: "absolute",
                top: 10,
                right: 15,
              }}
            >
              <CloseIcon />
            </IconButton>
          </Box>
          <Typography
            dangerouslySetInnerHTML={{ __html: fullText }}
          />
          <Box textAlign="right" mt={2}>
            <Button variant="contained" className="btn btn-default" onClick={handleClose}>
              Close
            </Button>
          </Box>
        </Box>
      </Modal>
    </div>
  );
}

export default FirstDarkFooter;
